<template>
    <div :class="dropDownClasses">
        <div class="t1-dropdown__picture">
            <div class="pp-container">
                <img class="profile-pic" :src="profilePicture" alt="Profile Picture">
                <div class="icon-container">
                    <img src="/img/icons/pencil.svg" class="icon">
                </div>
            </div>
            <p class="profile-email mt-5">{{ showName }}</p>
        </div>
        <div class="t1-dropdown__options">
            <ul>
                <li @mousedown="goToDocuments">Documentos requeridos</li>
                <li @mousedown="goToFrecuent">FAQ's preguntas frecuentes</li>
                <li @mousedown="logout" @mouseover="exitMenuHover('over')" @mouseleave="exitMenuHover">Cerrar sesión<img width="20px" height="20px" :src="'/img/icons/'+exitIcon" class="icon"></li>
            </ul>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        name: "DropdownMenu",
        data(){
            return {
                exitIcon: 'exit.svg'
            }
        },
        computed: {
            ...mapGetters({
                getDropdown: "getDropdown",
                nombre: "getName",
                lastName: "getLastName",
                motherLastName: "getMothersLastName",
                email: "getEmail",
                documents: "getDocuments"
            }),
            dropDownClasses(){
                return `t1-dropdown${this.visible}`;
            },
            visible(){
                return this.getDropdown ? ` t1-dropdown--open` : ``;
            },
            showName(){
                return this.nombre ? this.nombre+' '+this.lastName+' '+this.motherLastName : "Solicitante" ;
            },
            profilePicture(){
                let file = this.documents.filter(function(item){
                    return item.documentType=='PROFILE_PICTURE'
                });
                
                return file.length>0 ? file[0].publicURL : 'https://www.postplanner.com/hs-fs/hub/513577/file-2886416984-png/blog-files/facebook-profile-pic-vs-cover-photo-sq.png?width=250&height=250&name=facebook-profile-pic-vs-cover-photo-sq.png';
            }

        },
        methods: {
            ...mapActions(["logOut", "setDropdown"]),
            async logout() {
                await this.setDropdown(false);
                await this.logOut();
                this.$router.push('/');
            },
            exitMenuHover(event){
                if(event == 'over'){
                    this.exitIcon = 'exit-hover.svg';
                } else {
                    this.exitIcon = 'exit.svg';
                }
            },
            goToDocuments(){
                this.$router.push("/documentsRequest")
                this.$store.commit("_setDropdown", false)

            },
            goToFrecuent(){
                this.$router.push("/frequentQuestions")
                this.$store.commit("_setDropdown", false)

            }
        }
    }
</script>